/*
 * source data is 2d-array of [date, value]
 *
 * convert it to use like `d.value` instead of `d[1]`,
 * parse dates and sort by date
 */

import {toDate} from './date.js'

export default data => {
  return data.map(d => {
    return {
      date: toDate(d[0]),
      value: d[1]
    }
  })
}



// WEBPACK FOOTER //
// ./src/components/station-infobox/transform_history_data.js